import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { ProjectProvider } from '../../contexts/ProjectContext';
import { NotificationProvider } from '../../contexts/NotificationContext';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

const AppLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <NotificationProvider>
      <ProjectProvider>
        <div className="app-layout">
          <Sidebar
            collapsed={sidebarCollapsed}
            mobileOpen={mobileOpen}
            onCloseMobile={() => setMobileOpen(false)}
          />

          <Topbar
            collapsed={sidebarCollapsed}
            onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)}
            onToggleMobile={() => setMobileOpen(!mobileOpen)}
          />

          <main className={`main-content ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
            <Outlet />
          </main>
        </div>
      </ProjectProvider>
    </NotificationProvider>
  );
};

export default AppLayout;
